module.exports = __webpack_public_path__ + "static/img/13.ab761db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/zh/13.png
// module id = QzjO
// module chunks = 0